import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { EnumRendererComponent } from './enum-renderer.component';

@NgModule({
  declarations: [ EnumRendererComponent ],
  exports: [ EnumRendererComponent ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  providers: [
    TranslatePipe
  ]
})
export class EnumRendererModule { }
